export default "__VITE_ASSET__BEg51l7z__"